import {
  Box,
  Heading,
  List,
  ListItem,
  Link,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import { EmailIcon } from "@chakra-ui/icons";
import React, { ReactNode } from "react";
import { TournamentType } from "../../service/tournament";

// Optional: reusable styled list item
const StyledListItem: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <ListItem ml={"4px"}>
      <Text fontFamily={"Arial"} fontWeight={900}>
        {children}
      </Text>
    </ListItem>
  );
};

type TournamentExtraInfoProps = {
  tournamentInfo: TournamentType | null;
};

export const TournamentExtraInfo: React.FC<TournamentExtraInfoProps> = ({
  tournamentInfo,
}) => {
  return (
    <Box
      backgroundColor="#139D08"
      width={{
        base: "326px",
        sm: "422px",
        md: "634px",
        lg: "845px",
        xl: "1056px",
      }}
      pb="10px"
    >
      <Heading textAlign={"center"} pb={3}>
        Bijkomende informatie
      </Heading>
      <List spacing={3} paddingLeft="20px" styleType="disc">
        <StyledListItem>
          Locatie: The Corner, Lavendelstraat 27, 9400 Ninove.
        </StyledListItem>
        <StyledListItem>
          Datum: {tournamentInfo?.formatted_date || "nog te bepalen"}.
        </StyledListItem>
        <StyledListItem>
          Plaatsen beperkt tot{" "}
          {tournamentInfo?.max_players || "een nog te bepalen aantal"} personen,
          dus wees er snel bij!
        </StyledListItem>
        <StyledListItem>
          Aanmelden ter plaatse + bekendmaking wedstrijdschema:{" "}
          {tournamentInfo?.formatted_time || "nog te bepalen"}.
        </StyledListItem>
        <StyledListItem>
          Inschrijvingsgeld: €20.
          <br />
          Om alles in goede banen te leiden en iedereen een gelijke kans te
          geven op deelname, vragen wij je om je inschrijvingsgeld van 20 euro
          te storten op rekeningnummer BE08 1030 7303 5513 vóór{" "}
          {tournamentInfo?.formatted_registration_deadline ||
            "14 dagen voor het toernooi"}{" "}
          met vermelding van deze mededeling: Biljart + je volledige naam.
          <br />
          LET OP: JE INSCHRIJVING IS PAS DEFINITIEF NA ONTVANGST VAN JE
          INSCHRIJVINGSGELD OP BOVENVERMELDE BANKREKENING.
          <br />
          Mocht je je toch bedenken en willen uitschrijven, dan kunnen we je
          inschrijvingsgeld alleen terugstorten als je dit vóór{" "}
          {tournamentInfo?.formatted_registration_deadline ||
            "14 dagen voor het toernooi"}{" "}
          doet.
          <br />
          Dit prijzengeld wordt verdeeld onder de eerste 4 winnaars.
        </StyledListItem>
        <StyledListItem>
          Wedstrijdreglement volgens International 8-ball rules. Samenvatting
          van het reglement:{" "}
          <Link
            href="/assets/files/Samenvatting_regels_competitie_2024.pdf"
            target="_blank"
          >
            KLIK HIER
          </Link>{" "}
          <br />
          (Volledig reglement, zie 'Reglement' in menu)
        </StyledListItem>
        <StyledListItem>
          <Text fontWeight="bold">Poulefase</Text>
          <UnorderedList>
            <ListItem>
              Aantal tafels: Er wordt gespeeld op 5 biljarttafels.
            </ListItem>
            <ListItem>
              Poule-indeling: We hebben 5 poules van elk 4 personen.
            </ListItem>
            <ListItem>
              Wedstrijden: Elke wedstrijd wordt gespeeld in een 'race to 2'
              formaat.
            </ListItem>
            <ListItem>
              De beste spelers gaan door naar de knock-out fase
            </ListItem>
          </UnorderedList>
        </StyledListItem>
        <StyledListItem>
          <Text fontWeight="bold">Knock-out fase</Text>
          <UnorderedList>
            <ListItem>
              Deze fase wordt gespeeld tot er uiteindelijk 4 spelers
              overblijven.
            </ListItem>
            <ListItem>
              Deze 4 spelers spelen een wedstrijd in de halve finale.
            </ListItem>
            <ListItem>
              De winnaars van elke halve finale wedstrijd spelen de finale.
            </ListItem>
          </UnorderedList>
        </StyledListItem>
        <StyledListItem>
          Verdere info of vragen over je inschrijving:{" "}
          <EmailIcon boxSize="1em" mr="2" />
          <Link
            href="mailto:deschevestoot@hotmail.com?subject=Toernooi%202023-07-15"
            color="white"
          >
            deschevestoot@hotmail.com
          </Link>
        </StyledListItem>
      </List>
    </Box>
  );
};
